import {AfterViewInit, Component, ElementRef, Renderer2} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ELocale } from 'src/model/enum/sic-ania/locale.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    translate.setDefaultLang(ELocale.IT);
    translate.use(ELocale.IT);
  }

}
